import { render, staticRenderFns } from "./EditarRecepcionActividadModal.vue?vue&type=template&id=10d09562&"
import script from "./EditarRecepcionActividadModal.vue?vue&type=script&lang=ts&"
export * from "./EditarRecepcionActividadModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports